// extracted by mini-css-extract-plugin
export default {"dynamic-media-picture":"ZNzvkLv","transparent":"p4Aqr7N","loading":"prNhteb","noLogo":"Dd2OKiv","image":"wO1u6nT","objectFit":"Ywkokp4"};